import React, {Component} from 'react';
import * as d3 from "d3";
import './legendWarmingStripes.scss';

const isSiteInDarkMod = () => {
  const el = document.querySelector('html[data-theme]');

  if (el) {
    const {theme} = el.dataset;

    if (theme) {
      return theme === 'dark';
    }
  }
  return false;
};

class LegendWarmingStripes extends Component {
  constructor(props) {
    super(props);

    const {limits, colours} = this.props;
    this.limits = limits;
    this.colours = colours;
    this.placeholderLegend = React.createRef();
    this.legendEntryRadius = 4
    this.legendEntryMargin = this.legendEntryRadius * 0.5
    this.themeSwitchHandler = this.themeSwitchHandler.bind(this);
    this.themeSwitcher = this.getThemeSwitcher();
    this.state = {
      siteInDarkMod: isSiteInDarkMod(),
    };
  }

  componentDidMount() {
    const threshold = d3
      .scaleThreshold()
      .domain(this.limits)
      .range(this.colours);

    let legend = d3.select(this.placeholderLegend.current);

    const valuesColorMapping = threshold.range().map((color) => {
      const d = threshold.invertExtent(color);
      return [d, color];
    });

    valuesColorMapping.forEach((value, i) => {
      legend.append("circle")
        .attr("cx", i * ((this.legendEntryRadius * 2) + this.legendEntryMargin) + (this.legendEntryRadius))
        .attr("cy", this.legendEntryRadius)
        .attr("r", this.legendEntryRadius)
        .style("fill", value[1])
    });

    this.themeSwitcher.addEventListener();
  }

  componentWillUnmount() {
    this.themeSwitcher.removeEventListener();
  }

  themeSwitchHandler() {
    this.setState({siteInDarkMod: isSiteInDarkMod()});
  }

  getThemeSwitcher() {
    const items = document.querySelectorAll('.theme-switcher');

    return {
      addEventListener: () => {
        items.forEach((item) => {
          item.addEventListener('click', this.themeSwitchHandler);
        });
      },
      removeEventListener: () => {
        items.forEach((item) => {
          item.removeEventListener('click', this.themeSwitchHandler);
        });
      },
    };
  };

  render() {
    const {limits, colours} = this.props;
    const {siteInDarkMod} = this.state;
    const width = ((limits.length - 1) * ((this.legendEntryRadius * 2) + this.legendEntryMargin)) - this.legendEntryMargin;
    const minValueColor = siteInDarkMod ? colours[3] : colours[0];
    const maxValueColor = siteInDarkMod ? colours[colours.length - 4] : colours[colours.length - 1];
    const minValue = Math.min(...limits).toString().replace(".",",");
    const maxValue = Math.max(...limits).toString().replace(".",",");

    return (
      <div className="warming-stripes-legend">
        <span className="min" style={{color: minValueColor}}> {minValue} °C</span>
        <svg
          className="svg"
          ref={this.placeholderLegend}
          height={this.legendEntryRadius * 2}
          width={width}
        />
        <span className="max" style={{color: maxValueColor}}>{maxValue} °C</span>
      </div>)
  }
}

export default LegendWarmingStripes;
